<template>
	<div class="business-logo-view">
		<v-toolbar flat fixed>
            <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
            <v-toolbar-title class="white--text">Business Logo</v-toolbar-title>
        </v-toolbar>

		<div class="hasToolbar">
			<v-alert type="info" :value="true">
                <div>Upload your business logo.</div>
                <div>Business logo will appear in all invoice templates.</div>
            </v-alert>

			<v-card padding-all-16 flat>
				<v-card-text nopadding center-align>
					<p class="title" style="line-height:28px !important">
		            	{{$root.CurrentBusiness.BusinessName}}
		            </p>
					<!-- <img :src="$root.CurrentBusiness.businessLogo" v-if="$root.CurrentBusiness.businessLogo" class="logo-img"/> -->
					<!-- <div grey-back class="logo-placeholder"><v-icon>insert_photo</v-icon></div> -->
					<img :src="$root.CurrentBusiness.businessLogo" @click="fn_pickImage" v-if="$root.CurrentBusiness.businessLogo" class="logo-img"/>
					<div grey-back class="logo-placeholder" v-else @click="fn_pickImage" v-ripple>Logo</div>
				</v-card-text>
				<!-- <v-btn color="primary" block @click="fn_pickImage">{{$root.CurrentBusiness.businessLogo ? 'Change' : 'Upload'}}</v-btn> -->
				<!-- <v-btn color="primary" class="mt-2" block outline outline @click="fn_openConfirmationDialog" v-if="$root.CurrentBusiness.businessLogo">Remove</v-btn> -->
			</v-card>

			<!-- <v-btn color="success" @click="$refs['ref_dailogCropImage'].dialog_crop_image=true">text</v-btn> -->


			<!-- <input type="file" @change="croppie"/>
			  <vue-croppie ref="croppieRef" :enableOrientation="false" :boundary="{ width: 300, height: 250}" :viewport="{ width:200, height:200, 'type':'square' }" :enableResize="false">
			  </vue-croppie>
			  <img :src="cropped">
			  <button @click="crop">Crop</button> -->

			<div white-background full-width nopadding style="position:fixed;bottom:0;">
				<v-layout row wrap>
					<!-- <v-flex xs6 sm6 md6 style="padding:6px 6px 6px 16px" @click="fn_openDialog_PaymentOptions('yes')" v-ripple>
						<div font-medium style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">&#8377; {{Form.amount ? Form.amount : 0}}</div>
						<div style="font-size:11px">
							{{!Form.splitPayment ? fn_paymentAccountName(Form.paymentLedgerId) : 'Split Payment'}}
							<v-icon font16 style="line-height:12px">arrow_drop_down</v-icon>
						</div>
					</v-flex> -->
					<v-flex xs6 sm6 md6 height48 v-if="$root.CurrentBusiness.businessLogo">
						<v-btn style="background:#F0F0F0" full-height nomargin block no-round-borders noshadow @click="fn_openConfirmationDialog">Remove</v-btn>
					</v-flex>
					<v-flex :class="[$root.CurrentBusiness.businessLogo ? 'xs6 sm6 md6' : 'xs12 sm12 md12']" height48>
						<v-btn color="primary" full-height nomargin block no-round-borders noshadow @click="fn_pickImage">{{$root.CurrentBusiness.businessLogo ? 'Change' : 'Upload'}}</v-btn>
					</v-flex>
				</v-layout>
			</div>
		</div>

		<dialog-confirmation ref="ref_dialogConfirmation" header="Remove Business Logo?" :actionMethod="fn_removeLogo"></dialog-confirmation>
		<dialog-crop-image ref="ref_dailogCropImage"></dialog-crop-image>

		<!-- <cropper
			class="cropper"
			:src="$root.CurrentBusiness.businessLogo"
			:stencil-props="{
			aspectRatio: 10/12
			}"
			@change="change"
		></cropper> -->

		 <!-- <cropper
      :src="$root.CurrentBusiness.businessLogo"
      :auto-zoom="true"
      class="cropper"
      image-class="cropper__image"
      :stencil-props="{
        class: 'cropper-stencil',
        previewClass: 'cropper-stencil__preview',
        draggingClass: 'cropper-stencil--dragging',
        handlersClasses: {
          default: 'cropper-handler',
          eastNorth: 'cropper-handler--east-north',
          westNorth: 'cropper-handler--west-north',
          eastSouth: 'cropper-handler--east-south',
          westSouth: 'cropper-handler--west-south',
        },
        handlersWrappersClasses: {
          default: 'cropper-handler-wrapper',
          eastNorth: 'cropper-handler-wrapper--east-north',
          westNorth: 'cropper-handler-wrapper--west-north',
          eastSouth: 'cropper-handler-wrapper--east-south',
          westSouth: 'cropper-handler-wrapper--west-south',
        },
      }"
    /> -->
		<!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->
	</div>
</template>

<script>
import dialogConfirmation from '../../dialogs/dialog_confirmation'
import dialogCropImage from './dialog_crop_image'
// import dialogPermission from '../../dialogs/dialog_permission';

import { Cropper } from 'vue-advanced-cropper'

	export default{
		components:{
			'dialog-confirmation': dialogConfirmation,
			'dialog-crop-image': dialogCropImage,
			Cropper
			// 'dialog-permission': dialogPermission,
		},
		methods:{

			change({coordinates, canvas}) {
				console.log(coordinates, canvas)
			},

			fn_pickImage: function(){
	            let self = this;
	            this.$root.fn_checkStoragePermission(function(){
	            	self.fn_selectFile();
	            });
	        },

	        fn_selectFile: function(){
	            let self = this;
	            this.getData('PickImage', null, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.fn_bindImage(response);
							// self.fn_uploadLogo("data:image/jpeg;base64," + response);
	                    },
	                    onError: function(error){
	                        console.log(error);
							if(error == 'size limit exceeds'){
								self.showToast("Max file size limit is 1MB");
							}
	                    }
	                }
	            );
	        },

	        fn_bindImage: function(imageUri){
	        	this.$refs['ref_dailogCropImage'].openDialogWeb(imageUri);
	        	// let self = this;
	        	// setTimeout(function(){
	        	// 	self.$refs['ref_dailogCropImage'].$refs.croppieRef.bind({
			    //       url: "data:image/jpeg;base64," + imageUri
			    //     });	
	        	// },300);
	        },

	        fn_uploadLogo: function(imgUri){
		    	let self = this;
	            let filterObject = {};
	            filterObject.businessLogo = imgUri;

	            this.postFilterData('UploadLogo', this.$root.CurrentBusiness.BusinessID, filterObject, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        // self.fn_backupAllBusinessData()
	                        self.$root.CurrentBusiness.businessLogo = imgUri;
	                        self.$refs['ref_dailogCropImage'].dialog_crop_image = false;
	                        self.showToast("Business logo updated");
	                        if(self.$route.query && self.$route.query.preview_template){
	                        	self.fn_goBack();
	                        }
	                    }, 
	                    onError: function(error){
	                        console.log(error);
	                        self.showToast('Something went wrong. Try again');
	                    }
	                }
	            );
		    },

	        // fn_uploadLogo: function(imgUri){
	        // 	let self = this;
	        //     this.getData('UploadLogo', imgUri, 
	        //         {
	        //             onSuccess: function(response){
	        //                 console.log(response);
	        //                 self.$root.CurrentBusiness.businessLogo = imgUri;
	        //                 self.$refs['ref_dailogCropImage'].dialog_crop_image = false;
	        //                 self.showToast("Business logo updated");
	        //                 if(self.$route.query && self.$route.query.preview_template){
	        //                 	self.fn_goBack();
	        //                 }
	        //             },
	        //             onError: function(error){
	        //                 console.log(error);
	        //             }
	        //         }
	        //     );
	        // },

	        // fn_uploadResponse: function(image){
	        // 	console.log(image);
	        // 	if(image){
	        // 		this.$root.CurrentBusiness.businessLogo = image;
		       //      this.hideLoading();
		       //      this.showToast("Business logo updated");
	        // 	}
	        // 	else{
	        // 		this.showToast("Something went wrong. Try again!.");	
	        // 	}
	        // },

	        // fn_getBusinessLogo: function(){
	        // 	let self = this;
	        //     this.getData('BusinessLogo', this.$root.CurrentBusiness.BusinessID, 
	        //         {
	        //             onSuccess: function(response){
	        //                 console.log(response);
	        //                 self.$root.CurrentBusiness.businessLogo = response;
	        //             },
	        //             onError: function(error){
	        //                 console.log(error);
	        //             }
	        //         }
	        //     );
	        // },

	        fn_openConfirmationDialog: function(){
	        	this.$refs['ref_dialogConfirmation'].openDialogWeb();
	        },

	        fn_removeLogo: function(){
	        	let self = this;
	        	this.fn_closeDialogConfimation();
	        	let postObj = {"businessId":this.$root.CurrentBusiness.BusinessID};
	            this.postData('RemoveBusinessLogo', postObj, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.$root.CurrentBusiness.businessLogo = null;
	                        self.showToast('Logo removed');
	                    },
	                    onError: function(error){
	                        console.log(error);
	                    }
	                }
	            );
	        },

	        fn_closeDialogConfimation: function(){
	        	this.$refs['ref_dialogConfirmation'].closeDialogWeb();
	        },

	        fn_closeDialogCropImage: function(){
	        	this.$refs['ref_dailogCropImage'].closeDialogWeb();
	        },

			fn_goBack: function(){
	            this.$router.go(-1);
	        },

	        // fn_openPermissionDialog: function(permissionType){
		    //     this.$root.permissionType = permissionType;
		    //     this.$refs['ref_dialogPermission'].dialog_permission = true;
		    // },

		    fn_closeDialog: function(){
		        // this.$refs['ref_dialogPermission'].dialog_permission = false;
		        this.fn_closeDialogConfimation();
		    }
		},
		mounted: function () {
	        window.js_globals.fn_onBackPress = this.fn_goBack;
	        // window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;
	        // window.js_globals.fn_uploadResponse = this.fn_uploadResponse;
	        // window.js_globals.showLoading = this.showLoading;
	    },
	    beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogConfirmation'].dialog_confimation || this.$refs['ref_dailogCropImage'].dialog_crop_image){
				this.fn_closeDialogConfimation();
				this.fn_closeDialogCropImage();
				// this.$refs['ref_dialogPermission'].dialog_permission = false;
				next(false);
			}
			else{
				next(true);
			}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/business_logo/logo.vue